module.exports = __webpack_public_path__ + "img/487.1a173791.jpg";